import React, { ReactNode } from 'react';
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
  type ThemeOptions,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryCacheProvider, AuthProvider, constants, baseTheme } from '@bento-dental/core';

interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  const theme = createTheme(baseTheme as ThemeOptions);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <QueryCacheProvider>
            <AuthProvider portal={constants.PORTALS.EMPLOYER} useStripe={true}>
              <CssBaseline />
              {children}
            </AuthProvider>
          </QueryCacheProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
}
